import CryptoJS from 'crypto-js';

/**
 * AES 解密函数（ECB 模式）
 * @param {string} encryptedText - Base64 编码的加密文本
 * @param {string} key - 用于解密的密钥（需要与加密时使用的密钥一致）
 * @returns {string} - 解密后的明文
 */
export function decryptAES(encryptedText) {
  const key = 'ACl6Sd1uKm9oAQMf'
  try {
      // 确保密钥长度适合 AES 加密（例如 AES-256 需要 32 字节）
      var keyBytes = CryptoJS.enc.Utf8.parse(key);
      var bytes = CryptoJS.AES.decrypt(encryptedText, keyBytes, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
      });

      // 获取解密后的文本
      var decryptedText = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedText);
      // document.getElementById('decrypted').innerText = decryptedText;

  } catch (e) {
      console.error("Error during decryption:", e);
  }
}
